import { TreeNode } from "@/types"
import cloneDeep from "lodash/cloneDeep"
import { TreeNodeVisibilityResult } from "@/types/treeNodeVisibilityResult"

export const treeFilter = {
	methods: {

		getFilterMatches (flatTree: TreeNode<any>[], filter: string): TreeNode<any>[] {
			const lowerFilter = filter.toLowerCase()
			return filter === "" ? flatTree : flatTree.filter(item => item.node.title.toLowerCase().indexOf(lowerFilter) > -1)
		},
		organiseFilterResults (filterMatches: TreeNode<any>[]): TreeNode<any>[] {
			let searchResults = []

			if (filterMatches) {
				let parentsToAdd: TreeNode<any>[] = []
				let parentsToAddBucket: TreeNode<any>[] = []
				// Show parent visibility back to root
				const makeParentVisible = (originalItem: TreeNode<any>) => {
					if (originalItem.parent) {
						makeParentVisible(originalItem.parent)
					}

					let itemClone = this.cloneTreeNodeWithoutChildren(originalItem)

					if (typeof itemClone === "undefined" || itemClone === null) {
						return
					}

					itemClone.children = []

					if (!parentsToAdd[itemClone.node.id]) {
						parentsToAdd[itemClone.node.id] = itemClone
						parentsToAddBucket.push(itemClone)
					}

					if (typeof itemClone.parent === "undefined" || itemClone.parent === null || itemClone.parent.node === null) {
						return
					}

					let parentFromList: TreeNode<any> = parentsToAdd[itemClone.parent.node.id]

					let parentExistsInList: boolean = parentFromList &&
						!!parentFromList.children

					if (parentExistsInList) {
						if (parentFromList.children) {
							let itemNotAlreadyAChild: boolean = !this.doesNodeExistInChildren(parentFromList.children, itemClone.node.id)
							if (itemNotAlreadyAChild) {
								parentFromList.children.push(itemClone)
							}
						}
					}
				}

				filterMatches.forEach(makeParentVisible)
				for (let topLevelItemId in parentsToAdd) {
					let item = parentsToAdd[topLevelItemId]

					// Item has no parent but has a node
					if (!item.parent && !!item.node) {
						searchResults.push(item)
					}
				}
			}
			return searchResults
		},
		setTreeVisibility (tree: TreeNode<any>[]): TreeNodeVisibilityResult {
			let flatList: TreeNode<any>[] = []
			let treeStructure: TreeNode<any>[] = []

			const setTreeChildItemVisibility = (item: TreeNode<any>) => {
				if (!item || !flatList || !treeStructure) {
					return
				}
				flatList.push(item)

				if (item.children) {
					item.children.forEach(childItem => {
						childItem.parent = item
						setTreeChildItemVisibility(childItem)
					})
				}
				if (typeof item.parent === "undefined") {
					treeStructure.push(item)
				}
			}

			if (tree) {
				tree.forEach(setTreeChildItemVisibility)
			}

			return {
				flatList: flatList,
				treeStructure: treeStructure
			} as TreeNodeVisibilityResult
		},
		doesNodeExistInChildren (children: TreeNode<any>[], nodeIdToFind: string) : boolean {
			return children.some(child => child.node.id === nodeIdToFind)
		},
		cloneTreeNodeWithoutChildren (treeNodeToClone: TreeNode<any>) : TreeNode<any> {
			let clone: TreeNode<any> = {
				node: cloneDeep(treeNodeToClone.node),
				children: [],
				visible: treeNodeToClone.visible
			}
			if (treeNodeToClone.parent) {
				clone.parent = this.cloneTreeNodeWithoutChildren(treeNodeToClone.parent)
			}
			return clone
		}
	}
}
